module.exports = __webpack_public_path__ + "img/software_icon3.f99d16e4.png";